import Vue from 'vue'
import Router from 'vue-router'

import { coreuiRoutes } from '@/router/routes';
import { appRoutes } from 'app/router/routes';
import { loadLanguageAsync } from 'vue-core/i18n';

import HttpInterceptor from 'vue-core/auth/HttpInterceptor';

Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '*',
      redirect: '/public/404'
    },
    {
      path: '/',
      redirect: () => HttpInterceptor.loggedIn ? '/protected' : '/public'
    },
    {
      path: '/',
      component: {
        template: '<router-view />',
      },
      children: [
        ...coreuiRoutes,
        ...appRoutes,
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const lang = to.query.lang

  HttpInterceptor.isLoggedAsync(to).then(
    () => loadLanguageAsync(lang).then(() => next()),
    () => {
      console.log("HttpInterceptor.isLoggedAsync failed: redirecting to login page");
      return next({
        path: '/public/login',
        query: { redirect: to.fullPath }
      });
    }
  );
})

export default router;
